import React from 'react';
import { MeridianSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/MeridianSelect/MeridianSelect';

export interface EndTimeMeridianSelectProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function EndTimeMeridianSelect({
  name,
  id,
  disabled = false,
}: EndTimeMeridianSelectProps): JSX.Element {
  return (
    <MeridianSelect
      ariaLabel="End time meridian"
      name={name}
      id={id}
      disabled={disabled}
    />
  );
}
